import { Phone, Mail, MapPin } from "lucide-react";
import { NC, telLink, mailLink } from "@/lib/nc";

const quickLinks = [
  { label: "Services", href: "#services" },
  { label: "Why NC", href: "#why" },
  { label: "Process", href: "#process" },
  { label: "Request Estimate", href: "#estimate" },
  { label: "Contact", href: "#contact" },
];

export const Footer = () => {
  return (
    <footer className="border-t border-border bg-background">
      <div className="container-nc grid gap-8 py-10 sm:gap-10 sm:py-14 md:grid-cols-[1.4fr_1fr_1.2fr]">
        {/* Brand */}
        <div>
          <img src="/assets/nc-logo-trim.png" alt="NC – No Contractor. Honesty. Understanding. Responsibility." className="h-16 w-auto" />
          <p className="mt-4 max-w-sm text-sm leading-relaxed text-muted-foreground">
            NC provides single-point responsibility for construction, renovation, repair and
            maintenance projects in {NC.city}.
          </p>
        </div>

        {/* Quick links */}
        <div>
          <h4 className="text-sm font-bold uppercase tracking-wide text-foreground">Explore</h4>
          <ul className="mt-4 space-y-2.5">
            {quickLinks.map((link) => (
              <li key={link.href}>
                <a
                  href={link.href}
                  className="text-sm text-muted-foreground transition-colors hover:text-primary"
                >
                  {link.label}
                </a>
              </li>
            ))}
          </ul>
        </div>

        {/* Contact */}
        <div>
          <h4 className="text-sm font-bold uppercase tracking-wide text-foreground">Contact</h4>
          <ul className="mt-4 space-y-3 text-sm">
            <li>
              <a href={telLink} className="flex items-start gap-3 text-muted-foreground hover:text-primary transition-colors">
                <Phone className="mt-0.5 h-4 w-4 shrink-0 text-gold" /> {NC.phoneDisplay}
              </a>
            </li>
            <li>
              <a href={mailLink} className="flex items-start gap-3 break-all text-muted-foreground hover:text-primary transition-colors">
                <Mail className="mt-0.5 h-4 w-4 shrink-0 text-gold" /> {NC.email}
              </a>
            </li>
            <li className="flex items-start gap-3 text-muted-foreground">
              <MapPin className="mt-0.5 h-4 w-4 shrink-0 text-gold" /> {NC.address}
            </li>
          </ul>
        </div>
      </div>

      <div className="border-t border-border">
        <div className="container-nc flex flex-col items-center justify-between gap-2 py-6 text-center text-xs text-muted-foreground sm:flex-row sm:text-left">
          <p>© 2026 NC – No Contractor. All rights reserved.</p>
          <p>Construction • Renovation • Repair • Maintenance</p>
        </div>
      </div>
    </footer>
  );
};
